import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CheckCircle, Mail, MapPin, Briefcase, Zap } from "lucide-react";
import { teamMembers } from '../companydata';


const TeamMembers = () => {
    return (
        <section className="team py-10 bg-white">
            <div className="container ">
                <div className="team-inner text-center ">
                    <div className="section-title mb-6">
                        <h6 className="text-uppercase green fw-medium mb-1">Our Team</h6>
                        <h2 className="fw-bold">
                            Our experienced <span className="green">team</span> members
                        </h2>
                    </div>

                    <div className="section-body">
                        <div className="row gy-4 ">
                            {teamMembers.map((member) => (
                                <div key={member.id} className="col-lg-4 col-md-6">
                                    <div className="team-box p-4 bg-white border border-2 border-lightgreen rounded-4 shadow-sm h-100 transition-hover">
                                        <div className=" mb-3">
                                            <h4 className="mb-1 fw-bold">
                                                <Link to="/team-detail" className="darkgreen text-decoration-none">
                                                    {member.name}
                                                </Link>
                                            </h4>
                                            <span className="green fw-semibold small">{member.role}</span>
                                            <p className="mt-2 text-muted small">
                                                {member.desc}
                                            </p>
                                            


                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default TeamMembers;